import { useEffect, useState } from 'react';
import {  Key,FC } from 'react';
import MapMarker from './mapMarker';
import Map, {Source, Layer,Marker,GeoJSONSource  } from 'react-map-gl';

const MarkerLayer =({handleModalData,items,coords})=>{
 return  items.map((item,i)=>
  <MapMarker i={i} item={item} handleModalData={handleModalData} coords={coords}/> 
//  <Source id="polylineLayer" type="geojson" data={lineData}>
//           <Layer
//             id="lineLayer"
//             type="line"
//             source="my-data"
//             layout={{
//               "line-join": "round",
//               "line-cap": "round"
//             }}
//             paint={{
//               "line-color": "rgba(3, 170, 238, 0.5)",
//               "line-width": 5
//             }}
//           />
//         </Source>
  


        
 )}
 
export default MarkerLayer